import { QRCodeSVG } from "qrcode.react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "./Button";
import { debounce } from "./debounce";
import { Spinner } from "./Spinner";
import {
    CheckoutSuccessSubStateKind,
    RootStateKind,
    useRootState
} from "./state/StateProvider";
import { ActionKind } from "../types/Action";

export const Receipt = () => {
    const { state, dispatch } = useRootState(RootStateKind.CheckoutSuccess);

    const { subState, orderId, kitchenOrder } = state;

    const { t } = useTranslation();

    const [printed, setPrinted] = useState(false);

    const printReceipt = async () => {
        await dispatch({
            kind: ActionKind.PrintReceipt,
            orderId,
            kitchenOrderId: kitchenOrder?.id
        });
        setPrinted(true);
    };

    const debouncedPrint = useMemo(
        () => debounce(printReceipt, 500, "immediate"),
        []
    );

    const PrintButton = () => {
        return printed ? (
            <div data-testid="receiptPrinted">{t("receiptPrinted")} </div>
        ) : (
            <Button
                variant="secondary"
                className="rounded-none px-8"
                onClick={debouncedPrint}
            >
                {t("printReceipt")}
            </Button>
        );
    };

    return (
        <div className="flex w-80 flex-col items-center gap-6 rounded-xl bg-white p-6">
            {subState.kind === CheckoutSuccessSubStateKind.ReceiptSuccess ? (
                <QRCodeSVG size={225} value={subState.receiptUrl} />
            ) : (
                <div className="grid h-[225px] place-content-center">
                    <Spinner />
                </div>
            )}
            <div className="text-center text-xl font-bold text-primary-800">
                {t("scanQRCode")}
            </div>
            <PrintButton />
        </div>
    );
};
